module.exports = "/_next/static/images/27080e4df2c5d713c886f2eb3b6d188f-chevron-left.svg";